import { render, staticRenderFns } from "./FilterNntTag.vue?vue&type=template&id=70bcaa93&scoped=true"
import script from "./FilterNntTag.vue?vue&type=script&lang=ts"
export * from "./FilterNntTag.vue?vue&type=script&lang=ts"
import style0 from "./FilterNntTag.vue?vue&type=style&index=0&id=70bcaa93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcaa93",
  null
  
)

export default component.exports